<template>
  <v-main tag="form">
    <AppBar/>
    <v-layout fill-height column>
      <v-container fluid flex-fill>
        <!--        nickname : {{ nickname }}<br />-->
        <!--        modNickname : {{ modNickname }}<br />-->
        <!--        nickCheck : {{ nickCheck }}<br />-->
        <!--        valid : {{ valid }}<br />-->

        <!-- 임시 아바타 선택 -->
        <div v-if="isSamsungFire">
          <p class="label fw-600 mb-5">프로필 이미지</p>
          <div class="text-center mb-5">
            <v-avatar size="100">
              <img :src="avatar.url"/>
            </v-avatar>
          </div>
          <v-row justify="center" no-gutters>
            <v-col cols="3" class="text-center" v-for="(item, index) in avatarImages" :key="index">
              <v-avatar size="60" @click="avatar = item">
                <img :src="item.url"/>
                <v-overlay absolute color="primary" :value="avatar === item">선택</v-overlay>
              </v-avatar>
            </v-col>
          </v-row>
          <v-divider class="my-5"/>
        </div>
        <!-- //임시 아바타 선택 -->

        <v-form class="form-item" v-model="valid">
          <label class="label">닉네임</label>
          <div class="input-group">
            <!--            <input type="text" v-model="modNickname" @input="value => inputNickname(value)">-->
            <v-text-field solo flat filled
                          ref="nickname"
                          v-model.trim="modNickname"
                          :rules="nickname_rule"
                          required
                          placeholder="한글, 영문, 숫자 10자 이내"
                          @input="value => inputNickname(value)"
                          @keydown.space.prevent
            />
            <v-btn :ripple="false"
                   depressed
                   color="primary"
                   class="btn-input"
                   @click="getUserReduNickname"
                   :disabled="modNickname === nickname || !valid || nickCheck === 0"
            >중복검사
            </v-btn>
          </div>
          <div class="px-3 mt-n2">
            <span class="lightBlue--text fs-12" v-if="valid && nickCheck === 0">사용가능한 닉네임입니다.</span>
            <span class="error--text fs-12" v-else-if="modNickname !== nickname && valid && nickCheck < 0">중복 검사를 진행해주세요.</span>
            <span class="error--text fs-12" v-else-if="nickCheck > 0">중복된 닉네임이 있습니다.</span>
            <span class="error--text fs-12" v-else-if="modNickname === nickname || valid || nickCheck === 0">사용 중인 닉네임입니다.</span>
          </div>
        </v-form>

      </v-container>
      <v-footer color="transparent" class="content-footer">
        <div class="content-buttons">
          <BlackBtn x-large block str="변경하기"
                    :disabled="((modNickname === nickname) || !valid || nickCheck !== 0) && ((avatar.key === originAvatar))"
                    @click="next"></BlackBtn>
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>
<script>
import store from '@/store'
import {mixinRemote, mixinAuth, mixinReward} from "@/mixins";
import BlackBtn from "@/components/btns/BlackBtn";

export default {
  components: {
    BlackBtn
  },
  mixins: [mixinRemote, mixinAuth, mixinReward],
  data: () => ({
    valid: false,
    nickCheck: -1,
    modNickname: '',
    originAvatar: null,
    avatar: null
  }),
  computed: {
    nickname_rule() {
      return [
        v => !!v || '필수 입력사항입니다.',
        v => /^[a-zA-Zㄱ-힣0-9]*$/.test(v) || '한글, 영문, 숫자만 (특수문자 제외) 입력 가능합니다.',
        v => !(v && v.length > 10) || '10자 이내로 입력 가능합니다.'
      ]
    }
  },
  created() {
    // this.modNickname = store.getters.nickname
    if(this.isSamsungFire){
      if (store.getters.profileAtchNo) this.avatar = this.avatarImages.filter(a => a.key === store.getters.profileAtchNo)[0]
      else this.avatar = this.avatarImages[0]
    }else{
      this.avatar = { key: store.getters.profileAtchNo, url: '' }
    }
    this.originAvatar = this.avatar.key
  },
  mounted() {
  },
  methods: {
    inputNickname() {
      // 중복 검사 이후 input 수정시 검사 상태 default
      this.nickCheck = -1
      // this.modNickname = this.modNickname.trim()
    },
    async getUserReduNickname() {
      await store.dispatch('getUserReduNickname', this.$_payload({'nickname': this.modNickname}))
          .then(res => {
            if (res.success) {
              this.nickCheck = res.data;

              if (this.nickCheck > 0) {
                // this.modNickname = '';
                this.$refs.nickname.focus()
              }
            } else {
              console.log(res.msg);
              // this.modNickname = '';
              this.$refs.nickname.focus()
            }
          })
          .catch(error => {
            console.error(error);
            // this.modNickname = '';
            this.$refs.nickname.focus()
          })
          .finally(() => {
          })
    },
    async next() {
      await store.dispatch('updateProfileAtchNo', this.$_payload(null, {profileAtchNo: this.avatar.key}))
          .then(async res => {
            if (res.success) {
              store.commit('setProfileAtchNo', this.avatar.key)
              await store.dispatch('setMemberInfo', this.$_payload('inData', {
                nickname: this.modNickname,
                profileAtchNo: this.avatar.key
              }))
                  .then(res => {
                    if (res.success) {

                      // 프로필 이미지 변경 코인획득 1회
                      if (this.avatar.key !== this.originAvatar) {
                        this.insertMemberCoin(this.userKey, 1, '0010')
                      }
                      //this.$router.push({ name: "내 정보 관리", params: { snackbar: "true"} });
                      store.commit('setNickname', this.modNickname)
                      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
                    } else {
                      console.log(res.msg)
                    }
                  })
                  .catch(error => {
                    console.error(error)
                  })
                  .finally(() => {
                  })
            } else {
              console.log(res.msg)
            }
          })
    },
  }
}
</script>
